import React, { useCallback, useContext, useEffect, useState } from 'react';
import PlaybackStartingTitle from './PlaybackStartingTitle';
import PlaybackStartingSubtitle from './PlaybackStartingSubtitle';
import PlaybackStartingActions from './PlaybackStartingActions';
import PlaybackStartingButtons from './PlaybackStartingButtons';
import { PlaybackContext } from '../../contexts/PlaybackContext';
import PlaybackStartingTranslateContainer from './PlaybackStartingTranslateContainer';
import { Button } from '../Button';

const TRANSITION_DURATION = 400;

const PlaybackStartingEntitlementLimit: React.FC = () => {
	const { reset, forceEntitlement, setNextPlaybackState } = useContext(PlaybackContext);
	const [buttonsVisible, setButtonsVisible] = useState(false);

	useEffect(() => {
		const timeout = setTimeout(() => setButtonsVisible(true), TRANSITION_DURATION);
		return () => clearTimeout(timeout);
	}, []);

	const onForceEntitlementPressed = useCallback(() => {
		setButtonsVisible(false);
		setNextPlaybackState();
		forceEntitlement();
	}, [forceEntitlement, setNextPlaybackState]);

	const onCancelPlaybackPressed = useCallback(() => {
		setButtonsVisible(false);
		reset();
	}, [reset]);

	return (
		<PlaybackStartingTranslateContainer visible={buttonsVisible} duration={TRANSITION_DURATION}>
			<PlaybackStartingTitle>{'Gat ekki hafið afspilun'}</PlaybackStartingTitle>
			<PlaybackStartingSubtitle>{'Afspilun er nú þegar í gangi á öðru tæki'}</PlaybackStartingSubtitle>
			<PlaybackStartingActions>
				<PlaybackStartingButtons>
					<Button title={'Taka yfir afspilun'} onClick={onForceEntitlementPressed} primary />
					<Button title={'Hætta við'} onClick={onCancelPlaybackPressed} />
				</PlaybackStartingButtons>
			</PlaybackStartingActions>
		</PlaybackStartingTranslateContainer>
	);
};

export default PlaybackStartingEntitlementLimit;
